import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { ClipboardService } from "ngx-clipboard";
import { OverlayPanel } from "primeng/overlaypanel";

@Component({
    selector: "m-copy-value",
    template: `
        <ng-container>
            {{ value }}
            <i class="pi pi-copy" (click)="copyValue($event)" [style.cursor]="'pointer'"></i>
        </ng-container>
        <p-overlayPanel appendTo="body">Copied!</p-overlayPanel>
    `,
    styles: []
})
export class CopyValueComponent {
    @Input()
    value: string;

    @ViewChild(OverlayPanel, { static: true })
    op: OverlayPanel;

    constructor(private clipboardService: ClipboardService) {}

    copyValue(ev: Event) {
        if (!this.value) {
            return;
        }
        this.clipboardService.copy(this.value);
        this.op.toggle(ev);
        setTimeout(() => this.op.overlayVisible && this.op.hide(), 2000);
    }
}
